import { IncrementMapper } from './increment-mapper';

export class EndIncrementMapper extends IncrementMapper {
  initialized = false;

  map(increment: number): number {
    return increment >= this.maxIncrement ? this.maxIncrement : 0;
  }
}
